import authApiClient from 'services/authApi';
import { setAccessToken, setRefreshToken, getRefreshToken, clearTokens } from 'services/api';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface RefreshResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await authApiClient.post<AuthResponse>('/api/auth/login', credentials);
    const { access_token, refresh_token } = response.data;

    // Store tokens
    setAccessToken(access_token);
    setRefreshToken(refresh_token);

    return response.data;
  }

  async refreshAccessToken(): Promise<string> {
    const refreshToken = getRefreshToken();

    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    const response = await authApiClient.post<RefreshResponse>('/api/auth/refresh', {
      refresh_token: refreshToken,
    });

    const { access_token, refresh_token } = response.data;
    setAccessToken(access_token);
    setRefreshToken(refresh_token);

    return access_token;
  }

  logout(): void {
    clearTokens();
  }
}

export default new AuthService();
